import { Navbar } from './Navbar';
import { useState, useEffect } from 'react';
import { LogOut, Eye, User } from 'lucide-react';

const ImpersonationBanner = () => {
    const [impersonation, setImpersonation] = useState(null);
    
    useEffect(() => {
        const data = localStorage.getItem('impersonation');
        if (data) {
            try {
                setImpersonation(JSON.parse(data));
            } catch (e) {
                console.error('Error parsing impersonation data:', e);
            }
        }
    }, []);
    
    const handleExitImpersonation = () => {
        if (impersonation) {
            // Restore original admin session
            localStorage.setItem('token', impersonation.originalToken);
            localStorage.setItem('user', JSON.stringify(impersonation.originalUser));
            localStorage.removeItem('impersonation');
            
            // Redirect back to admin clients page
            window.location.href = '/admin/clients';
        }
    };
    
    if (!impersonation) return null;
    
    return (
        <div className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-4 py-2 flex items-center justify-between shadow-md sticky top-0 z-50">
            <div className="flex items-center gap-3">
                <Eye className="w-5 h-5" />
                <span className="text-sm font-medium">
                    Mode visualisation client : <strong>{impersonation.impersonatedUser?.company_name || impersonation.impersonatedUser?.email}</strong>
                </span>
                <span className="text-xs text-purple-200">
                    (Connecté par : {impersonation.impersonatedBy})
                </span>
            </div>
            <button
                onClick={handleExitImpersonation}
                className="flex items-center gap-2 bg-white/20 hover:bg-white/30 px-4 py-1.5 rounded-lg text-sm font-medium transition-colors"
            >
                <LogOut className="w-4 h-4" />
                Retour Admin
            </button>
        </div>
    );
};

export const Layout = ({ children, showNavbar = true }) => {
    return (
        <div className="min-h-screen bg-white">
            <ImpersonationBanner />
            {showNavbar && <Navbar />}
            <main>{children}</main>
        </div>
    );
};

export default Layout;
